export const newBookingRoutes = {
  accommodations: '/',
  guestInfo: '/information',
  tours: '/tours',
  summary: '/summary',
  payment: '/payment',
  confirmation: '/confirmation',
}

const routes = {
  newBookingBase: `/book${newBookingRoutes.accommodations}`,
  newBookingGuestInfo: `/book${newBookingRoutes.guestInfo}`,
  newBookingTours: `/book${newBookingRoutes.tours}`,
  newBookingSummary: `/book${newBookingRoutes.summary}`,
  newBookingPayment: `/book${newBookingRoutes.payment}`,
  newBookingConfirmation: `/book${newBookingRoutes.confirmation}`,
  myAccountBase: '/account',
  myAccountProfile: '/account/profile',
  myAccountItineraryDetails: '/account/itinerary',
  addTour: '/account/itinerary/add-tour',
  addTourConfirmation: '/account/itinerary/add-tour/confirmation',
  addTourPayment: '/account/itinerary/add-tour/payment',
  confirmation: '/book/confirmation',
  itineraryFinalization: '/book/itinerary',
}

export const checkRouteMatch = (location, route) =>
  location.pathname === route ||
  `${location.pathname}/` === route ||
  location.pathname === `${route}/`

export default routes
